<main class="main-start">
  <div class="content">
    <form [formGroup]="form">
      <div class="form-title" i18n="@@start.text.title">
                Registrieren
            </div>
      <div class="form-group">
        <p class="label" i18n="@@start.input.whatAppliesToYou?">Was trifft auf Sie zu?</p>
        <button (click)="selectRecipient()" [class]="isRecipient ? 'active' : ''"
          class="information-text information-text--button" type="button">
          <p class="information-text__title" i18n="@@start.input.title.iAmRecipient">Ich suche Assistenz</p>
          <p class="information-text__content" i18n="@@start.input.content.iAmRecipient">Wünschen Sie sich
                        eine Assistenz im Alltag?</p>
          @if (isRecipient) {
            <span aria-hidden="true" class="icon icon-check icon-front"></span>
          }
        </button>
        <button (click)="selectGiver()" [class]="isGiver ? 'active' : ''"
          class="information-text information-text--button information-text--recipient" type="button">
          <p class="information-text__title" i18n="@@start.input.title.iAmGiver">Ich biete Assistenz</p>
          <p class="information-text__content" i18n="@@start.input.content.iAmGiver">Auf der Suche nach einem
                        Job als Assistenzperson.</p>
          @if (isGiver) {
            <span aria-hidden="true" class="icon icon-check icon-front"></span>
          }
        </button>
      </div>
      <div class="form-group">
        <label class="label" for="input-email-giver" i18n="@@start.input.email">E-Mail</label>
        <input
          class="input large"
          formControlName="email"
          i18n-placeholder="@@start.placeholder.email"
          id="input-email-giver"
          placeholder="Ihre E-Mailadresse"
          type="email"
          >
        @if (emailControl.invalid && (emailControl.touched || emailControl.dirty)) {
          <div
            class="validation error" i18n="@@start.error.email">
                    Bitte geben Sie eine gültige E-Mail Adresse ein.
                </div>
        }
      </div>
      <div class="form-group">
        <div class="form-check">
          <input formControlName="agb" id="input-accept-terms-giver" type="checkbox">
          <span i18n="@@start.checkbox.agb">
            <label for="input-accept-terms-giver">Ich akzeptiere</label>
            die
            <a [href]="linkToAGB" target="_blank">AGBs</a>
            und die
            <a [href]="linkToDSE" target="_blank">DSE</a>
            der CléA Assistenzplattform.
          </span>
        </div>
        @if (agb.invalid && (agb.touched || agb.dirty)) {
          <div class="validation error"
            i18n="@@start.error.agb">
                    Bitte akzeptieren Sie die AGB.
                </div>
        }
      </div>
      <div class="form-group">
        <button (click)="register()" [disabled]="!(isGiver || isRecipient)" class="button primary large block">
          @if (isGiver) {
            <ng-container i18n="@@start.btn.registerAsGiver">Als Assistent/in registrieren
                    </ng-container>
          }
          @if (!isGiver) {
            <ng-container i18n="@@start.btn.registerAsRecipient">Als Assistenznehmer/in
                        registrieren
                    </ng-container>
          }
        </button>
      </div>
      <div class="form-group text-center">
        <button (click)="login()" class="link login" i18n="@@start.btn.alreadyRegistered" type="button">Bereits
                    ein Konto? <span>Einloggen</span></button>
        </div>
      </form>
    </div>
    <div class="start-background"></div>
  </main>
